<template>
  <div>
    <p>Mostrar opciones de configuración de notificaciones para el usuario logueado.</p>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAccountNotificationsConfiguration'
}
</script>
